import React, { Suspense, lazy } from "react";
import { View, ActivityIndicator } from "react-native";
import Colours from "./Colours";

const Fallback = () => (
  <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
    <ActivityIndicator size="large" color={Colours.PRIMARY} />
  </View>
);

export const lazyScreen = (loader) => {
  const Screen = lazy(loader);
  return function LazyScreen(props) {
    return (
      <Suspense fallback={<Fallback />}>
        <Screen {...props} />
      </Suspense>
    );
  };
};
